export default function getCheckoutQuoteSessionId(state: App.State): string {
  return state.checkout.cart.cartId || state.checkout.cart.transactionKey
}
